module.exports = __webpack_public_path__ + "static/media/amelia.5c7fb244.png";